export interface WishlistOccasion {
	code: string;
	label: string;
}

/**
 * The Hybris `WishlistOccasionEnumeration` codes a list can be created with,
 * in the order the legacy create page offered them.
 */
export const WISHLIST_OCCASIONS: readonly WishlistOccasion[] = [
	{ code: "Wedding", label: "Wedding" },
	{ code: "HouseWarming", label: "Housewarming" },
	{ code: "CharitableEvent", label: "Charitable Event" },
	{ code: "MothersDay", label: "Mother's Day" },
	{ code: "FathersDay", label: "Father's Day" },
	{ code: "Christmas", label: "Christmas" },
	{ code: "Hanukkah", label: "Hanukkah" },
	{ code: "Birthday", label: "Birthday" },
	{ code: "Anniversary", label: "Anniversary" },
	{ code: "Other", label: "Other" }
];

export function isWishlistOccasion(code: string): boolean {
	return WISHLIST_OCCASIONS.some((occasion) => occasion.code === code);
}
